<template>
  <section class="section">
    <nav class="level is-vcentered">
      <div class="level-left">
        <div class="level-item">
          <img class="level-item-img" src="@/assets/icon/servicios-level.png" alt="Servicios">
          <h1 class="title">Detalle de Servicio</h1>
        </div>
      </div>
    </nav>
    <main class="inner-section">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-12">
            <a class="link_back is-inline-flex" @click="$router.go(-1)">
              <span class="arrow_back material-icons">
                arrow_back
              </span>
              <p>
                Regresar
              </p>
            </a>
          </div>
          <div class="column is-12">
            <div class="tabs is-toggle">
              <ul>
                <li :class="[ optionSelect === 'service' ? 'is-active' : '']">
                  <a @click="optionSelect='service'">
                    <span>Servicios</span>
                  </a>
                </li>
                <li :class="[ optionSelect === 'results' ? 'is-active' : '']">
                  <a @click="optionSelect = 'results'">
                    <span>Resultados</span>
                  </a>
                </li>
                <li :class="[ optionSelect === 'invoice' ? 'is-active' : '']">
                  <a @click="optionSelect = 'invoice'">
                    <span>Factura</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="optionSelect === 'service'" class="column is-12">
            <div class="box">
              <div class="columns is-multiline">
                <div class="column is-12">
                  <service-information
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="optionSelect === 'results'" class="column is-12">
            <results />
          </div>
          <div v-if="optionSelect === 'invoice'" class="column is-12">
            <invoices
              :serviceId="parseInt(serviceId)"
            />
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: 'ServiceDetail',
  components: {
    ServiceInformation: () => import('@/components/services/ServiceInformation.vue'),
    Results: () => import('@/components/services/Results.vue'),
    Invoices: () => import('@/components/services/Invoices.vue')
  },
  data () {
    return {
      optionSelect: 'service',
      serviceId: this.$route.params.serviceId
    }
  }
}
</script>

<style lang="scss" scoped>
  .section {
    width: 100%;
    min-height: calc(100vh - 90px);
    padding: 0;
  }
</style>
